import MyClaimOverviewPageActionTypes from '../actions/my-claim-overview-page-action-types';

const initialState = {
  loading: false,
  claim: null,
  pdfObjectUrl: null,
  cancelToken: null,
  isDeleteDialogVisible: false
};

export default function MyClaimOverviewPageReducer(state = initialState, action) {
  switch (action.type) {
    case MyClaimOverviewPageActionTypes.LOAD_MY_CLAIM_OVERVIEW_START:
      return { ...state, loading: true };
    case MyClaimOverviewPageActionTypes.LOAD_MY_CLAIM_OVERVIEW_END:
      return { ...state, loading: false, claim: action.payload?.claim ?? null, pdfObjectUrl: action.payload?.pdfObjectUrl ?? null };
    case MyClaimOverviewPageActionTypes.TOGGLE_DELETE_CLAIM_DIALOG:
      return { ...state, isDeleteDialogVisible: !state.isDeleteDialogVisible };
    case MyClaimOverviewPageActionTypes.CLEANUP_MY_CLAIM_OVERVIEW:
      return { ...initialState };
    default:
      return state;
  }
}
